import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods, makeQueryStringFromObject } from '../apiHelper'

export const getAllSectionToYears = (_, parameters = {}) => {
  return requestWithPromise(
    `/public/section-to-years${makeQueryStringFromObject(parameters)}`,
    HttpMethods.GET,
    null,
    null
  )
}

export const getBySection = (section, user) => {
  return requestWithPromise(
    `/api/sections/${getIdOrNull(section)}/section-to-years`,
    HttpMethods.GET,
    null,
    user
  )
}
